import type { ConferenceConfig } from './types';

/**
 * 공통 기본 설정. 환경별 config에서 hosts/bosh/websocket 등을 오버라이드한다.
 */
const configDefault: Omit<ConferenceConfig, 'hosts' | 'bosh'> = {
  channelLastN: -1,
  disableSimulcast: false, // 시뮬캐스트 활성화 (적응형 비트레이트)

  // 비디오 해상도 제약: 안정적인 범위로 제한하여 끊김 방지
  constraints: {
    video: {
      width: {
        ideal: 1280,
        max: 1280,
        min: 320,
      },
      height: {
        ideal: 720,
        max: 720,
        min: 180,
      },
    },
  },

  p2p: {
    enabled: false, // P2P 비활성화 (서버 중계만 사용)
  },

  e2eping: { pingInterval: 10000, analyticsInterval: 30000 },

  // 브리지 데이터 채널 최적화: SCTP 사용으로 제어 메시지 전달 효율 향상
  bridgeChannel: {
    preferSctp: true,
  },

  connectionIndicators: {
    autoHide: false,
    enableAdaptiveMode: true,
    disabled: false,
  },

  videoQuality: {
    codecPreferenceOrder: ['AV1', 'VP9', 'VP8', 'H264'],
  },

  audioQuality: {
    stereo: false,
    enableOpusDtx: true,
    opusMaxAverageBitrate: 32000,
  },

  desktopSharingFrameRate: {
    min: 5,
    max: 5,
  },

  // 네트워크 적응성
  enableTcc: true,   // Transport-wide Congestion Control
  enableRtx: true,   // Retransmission
  enableRemb: true,  // Receiver Estimated Maximum Bitrate
  disableRtx: false,
  useTurnUdp: true,  // TURN UDP: NAT 환경에서 연결 안정성 향상

  // 통계 수집
  gatherStats: true,
  pcStatsInterval: 10000, // 10초 간격

  enableForcedReload: true, // 브리지 다운 시 강제 리로드로 세션 복구
};

export default configDefault;
